import queryString from 'qs';
import { CodeSnippetsServiceResponse, FetchSnippetProps } from '../serverTypes';
import { getSnippetsServiceUrl } from '../utils/snippetsService';

/**
 * fetches from code snippets service and returns raw response
 */
export const fetchSnippetsRaw = async (snippetsOptions: FetchSnippetProps): Promise<CodeSnippetsServiceResponse> => {
  try {
    const urlToFetch = getSnippetsServiceUrl(snippetsOptions);
    const urlWithOptions = `${urlToFetch}?${queryString.stringify(snippetsOptions)}`;
    const response = await fetch(urlWithOptions);
    return (await response.json()) as CodeSnippetsServiceResponse;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`error fetching ${message}`);
  }
};
